import {defineStore} from "pinia";

export const reportesBancoStore = defineStore("reportesBancoStore", {
    state: () =>
        ({
            loading: false as boolean,
            fechaLiteral: '' as string,
            resumenTotalizado: [] as any[],
            resumenTotalizadoTotales: [] as any[],
        }),
});
